import React from 'react';
import './LoadingSpinner.css';

/**
 * 加载动画组件
 */
function LoadingSpinner({ size = 'medium', message = '加载中...' }) {
    return (
        <div className="loading-spinner-container">
            <div className={`loading-spinner ${size}`}>
                <div className="spinner"></div>
            </div>
            {message && <p className="loading-message">{message}</p>}
        </div>
    );
}

export default LoadingSpinner;
